/* Cachet: enhance only the Tapijt navigation; leave Horizon as a fail-safe. */
(() => {
  if (window.cachetTapijtMenu) {
    window.cachetTapijtMenu.refresh();
    return;
  }

  const originals = new Map();
  const relevantSelector = 'header-menu, header-drawer, .cachet-tapijt-menu-controller';
  let pending = false;

  const pathOf = (value) => {
    try { return new URL(value, document.baseURI).pathname.replace(/\/+$/, ''); }
    catch { return ''; }
  };

  function restoreOriginals() {
    for (const [list, record] of originals) {
      if (list.isConnected && list.querySelector('[data-cachet-menu-item]')) {
        list.replaceChildren(...record.children.map((child) => child.cloneNode(true)));
        delete list.dataset.cachetTapijtVersion;
      }
    }
    originals.clear();
  }

  function updateList(list, mode, cards, version) {
    if (!list || !list.children.length || list.contains(document.activeElement)) return;
    const children = Array.from(list.children);
    if (list.dataset.cachetTapijtVersion === version && children.every((child) => child.hasAttribute('data-cachet-menu-item'))) return;

    // A hydration refresh may replace the original cards inside an existing UL.
    if (!children.some((child) => child.hasAttribute('data-cachet-menu-item'))) {
      originals.set(list, { children: children.map((child) => child.cloneNode(true)) });
    }
    const original = originals.get(list);
    if (!original) return;
    // Preserve Horizon's desktop column/tablet limits. The mobile row gets three.
    const count = mode === 'desktop' ? Math.min(3, original.children.length) : 3;
    const ratio = list.querySelector('.resource-card__media')?.style.getPropertyValue('--resource-card-aspect-ratio');
    const replacement = cards.slice(0, count).map((card, index) => {
      const item = card.cloneNode(true);
      if (mode === 'desktop') {
        item.className = original.children[index]?.className || 'mega-menu__content-list-item';
      } else {
        item.className = 'menu-drawer__featured-content-list-item menu-drawer__featured-content-list-item--product';
      }
      if (ratio) item.querySelector('.resource-card__media')?.style.setProperty('--resource-card-aspect-ratio', ratio);
      return item;
    });
    list.replaceChildren(...replacement);
    list.dataset.cachetTapijtVersion = version;
  }

  function apply() {
    pending = false;
    for (const list of originals.keys()) if (!list.isConnected) originals.delete(list);
    const controller = document.querySelector('[data-cachet-tapijt-menu]');
    const template = controller?.querySelector('template[data-cachet-menu-cards]');
    const cards = template ? Array.from(template.content.children) : [];
    if (!controller || cards.length !== 3) { restoreOriginals(); return; }
    const targetPath = pathOf(controller.dataset.menuPath);
    if (!targetPath) return;
    const version = controller.dataset.menuVersion;

    document.querySelectorAll('header-menu').forEach((menu) => {
      menu.querySelectorAll('a[href]').forEach((link) => {
        if (pathOf(link.getAttribute('href')) !== targetPath) return;
        let branch = link.parentElement;
        while (branch && branch !== menu) {
          const list = branch.querySelector('.mega-menu__content-list--products');
          if (list) { updateList(list, 'desktop', cards, version); break; }
          branch = branch.parentElement;
        }
      });
    });

    document.querySelectorAll('header-drawer .menu-drawer__submenu').forEach((submenu) => {
      const title = submenu.querySelector('.menu-drawer__title[href]');
      if (title && pathOf(title.getAttribute('href')) === targetPath) {
        updateList(submenu.querySelector('.menu-drawer__featured-content-list'), 'mobile', cards, version);
      }
    });
  }

  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(apply);
  }

  function isRelevant(node) {
    return node instanceof Element && (node.matches(relevantSelector) || node.closest(relevantSelector) || node.querySelector(relevantSelector));
  }

  function start() {
    const observer = new MutationObserver((records) => {
      if (records.some((record) => isRelevant(record.target) || [...record.addedNodes, ...record.removedNodes].some(isRelevant))) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
    document.addEventListener('focusout', (event) => { if (isRelevant(event.target)) schedule(); });
    schedule();
  }

  window.cachetTapijtMenu = { refresh: schedule };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
